// api.js
import axiosInstance from '../utils/axiosInstance';

export const setLocalStorage = (key, data) => {
  localStorage.setItem(key, JSON.stringify(data));
};

export const getLocalStorage = (key) => {
  return localStorage.getItem(key);
};
export const clearLocalStorage = () => {
  return localStorage.clear();
};

export const postWithoutToken = async (url, values) => {
  try {
    const response = await axiosInstance.post(url, values);
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const postWithToken = async (url, token, values) => {
  try {
    const response = await axiosInstance.post(url, values, { headers: { Authorization: `Bearer ${token}` } });
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const patchWithToken = async (url, token, values) => {
  try {
    const response = await axiosInstance.patch(url, values, { headers: { Authorization: `Bearer ${token}` } });
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const patchWithPdf = async (url, token, values) => {
  try {
    const response = await axiosInstance.patch(url, values, { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' } });
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const getWithToken = async (url, token) => {
  try {
    const response = await axiosInstance.get(url, { headers: { Authorization: `Bearer ${token}` } });
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const getWithoutToken = async (url) => {
  try {
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const deleteWithToken = async (url, token) => {
  try {
    const response = await axiosInstance.delete(url, { headers: { Authorization: `Bearer ${token}` } });
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const deleteWithoutToken = async (url) => {
  try {
    const response = await axiosInstance.delete(url);
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const deleteAllWithToken = async (url, token, values) => {
  try {
    const response = await axiosInstance.delete(url, { headers: { Authorization: `Bearer ${token}` }, data: values });
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};
export const deleteAllWithoutToken = async (url, values) => {
  try {
    // axios delete needs body inside { data }
    const response = await axiosInstance.delete(url, { data: values });
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const Chatbot_Update = async (url, token, values) => {
  try {
    const response = await axiosInstance.post(url, values, { headers: { Authorization: `Bearer ${token}` } });
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const patchAvtarWithToken = async (url, token, values) => {
  try {
    const response = await axiosInstance.patch(url, values, { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' } });
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};
